// May need to remove this if we end up not using Fluxible with Contentful,
// but keeping this in just in case
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import component from 'bundles/articles/routes';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';

export default function buildAppEnv() {
  const appEnv = new Fluxible({
    component,
  });

  appEnv.registerStore(ApplicationStore);
  appEnv.registerStore(NaptimeStore);

  return appEnv;
}
